const styles = {
  root: {
    border: '0',
    position: 'relative',
    '&.MuiPaper-root': {
      height: '100%!important',
    },
    '& .MuiCardContent-root': {
      paddingX: { xs: 0, lg: 2 },
      paddingY: { xs: 0, lg: 2 },
    },
  },

  cardLink: {
    paddingX: 2,
    marginBottom: 2,
  },
  link: {
    margin: '0 0 10px 10px',
    textDecorationColor: (theme) => ({
      xs: `${theme.palette.text.black}!important`,
    }),
  },

  button: {
    minWidth: 230,
  },

  subitemContainer: {
    marginTop: 0,
  },

  listItem: {
    fontSize: '13px!important',
  },
}

export default styles
